"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = require("../Box");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Flex is Box with display: flex
 */


var Flex = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Flex",
  componentId: "cw39ct-0"
})([""]);
exports.Flex = Flex;
Flex.defaultProps = {
  display: "flex"
};
Flex.displayName = "Flex";